function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { useParams } from 'react-router';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import DefaultArticle from './DefaultArticle.react';
import NewsArticle from './NewsArticle.react';
import ContactArticle from './ContactArticle.react';
import PageBanner from './PageBanner.react';
import ArticleWhiteSpace from './common/ArticleWhiteSpace.react';
var ArticlePage = function ArticlePage() {
  var _useParams = useParams(),
    articleID = _useParams.articleID;
  var _useLocation = useLocation(),
    pathname = _useLocation.pathname;
  var pages = useSelector(function (s) {
    return s.pages;
  });
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    page = _useState2[0],
    setPage = _useState2[1];
  var clientEnv = useSelector(function (s) {
    return s.app.clientEnv;
  });
  useEffect(function () {
    var url = pathname.replace(/\/$/, '');
    if (articleID) {
      setPage(pages[url === null || url === void 0 ? void 0 : url.replace(articleID, '').replace(/\/$/, '')]);
    } else setPage(pages[url]);
  }, [articleID, pathname, pages]);
  var articlesArr = [];
  if (page && 'articles' in page) {
    articlesArr = page.articles.filter(function (x) {
      var _x$articleID, _x$articleID$slug;
      return !articleID || ((_x$articleID = x.articleID) === null || _x$articleID === void 0 ? void 0 : (_x$articleID$slug = _x$articleID.slug) === null || _x$articleID$slug === void 0 ? void 0 : _x$articleID$slug.toLowerCase()) === (articleID === null || articleID === void 0 ? void 0 : articleID.toLowerCase());
    }).filter(function (x) {
      return clientEnv === 'local' || x.published.map(function (y) {
        return y.clientEnv;
      }).includes(clientEnv);
    }).sort(function (a, b) {
      return a.slot - b.slot;
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "page",
    id: "page"
  }, page && 'banner' in page && page.banner.isVisible && /*#__PURE__*/React.createElement(PageBanner, page.banner), articlesArr.map(function (x) {
    var article = x.articleID;
    if (!article) return null;
    if (article.type === 'news') return /*#__PURE__*/React.createElement(NewsArticle, {
      key: "article-".concat(article._id),
      article: article
    });
    if (article.type === 'contact') return /*#__PURE__*/React.createElement(ContactArticle, {
      key: "article-".concat(article._id),
      article: article
    });
    return /*#__PURE__*/React.createElement(DefaultArticle, {
      key: "article-".concat(article._id),
      article: article
    });
  }), /*#__PURE__*/React.createElement(ArticleWhiteSpace, {
    arr: articlesArr
  }));
};
export default ArticlePage;